import React, { useEffect, useState } from 'react';
import LoaderSpinner from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../common/DataTable';
import { numOfPage, UserRequestColumns } from '../../constant';
import BatchPagination from '../batch/BatchPagination';
import { approveUserSignup, getAllPendingUserList, rejectUserSignup } from '../../store/actions';
import { toast } from "react-toastify";

/* istanbul ignore next */
const UserRequest = () => {
    const [loader, setLoader] = useState(false);
    const { allPendingUsersDataStatus, allPendingUsersData } = useSelector((state) => state.UsersReducer);
    const [usersList, setUsersList] = useState([]);
    let dispatch = useDispatch();
    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'ASCENDING',
        searchkey: '',
    };
    const [filterData, setfilterData] = useState(dataLoad);

    useEffect(() => {
        fetchAllList();
    }, [filterData.numberOfPage, filterData.pageIndex, filterData.pageSize, filterData.sortColumn, filterData.sortOrder]);

    useEffect(() => {
        if (allPendingUsersDataStatus === 'PENDING') {
            setLoader(true);
        } else if (allPendingUsersDataStatus === 'SUCCESS') {
            setLoader(false);
        }
    }, [allPendingUsersDataStatus]);

    useEffect(() => {
        if (allPendingUsersData?.usersList) {
            let addlistIndex = allPendingUsersData?.usersList.map((item, index) => ({
                ...item,
                listIndex: index,
                isChecked: false,
            }));
            setUsersList(addlistIndex);
            if (allPendingUsersDataStatus === 'SUCCESS') {
                setfilterData({
                    ...filterData,
                    totalPages: Math.ceil(allPendingUsersData?.TotalRecords / filterData.pageSize),
                });
            }
        }
    }, [allPendingUsersData]);

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    const handleAction = async (item, type) => {
        let payloadData = {
            pendingSignupId: item.Id,
        }
        if (type === 'approve') {
            let signupRes = await approveUserSignup(payloadData);
            if (signupRes?.data?.Status === 200) {
                toast.success('User approved successfully');
            }
        } else if (type === 'delete') {
            let rejectSignupRes = await rejectUserSignup(payloadData);
            if (rejectSignupRes?.data?.Status === 200) {
                toast.success('Request rejected');
            }
        }
        fetchAllList();
    };

    const fetchAllList = () => {
        dispatch(getAllPendingUserList(filterData));
    }

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    User Requests
                </div>
                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}
                <div className="main_content_table_history">
                    <div className="tableFixHead pl-2 zIndex1">
                        {allPendingUsersDataStatus === 'SUCCESS' && (
                            <DataTable
                                headers={UserRequestColumns}
                                tableData={usersList}
                                actionType={8}
                                handleAction={handleAction}
                                handleSortingColumn={handleSortingColumn}
                                tableDataStatus={allPendingUsersDataStatus}
                                filterData={filterData}
                            />
                        )}
                    </div>
                </div>
                <BatchPagination
                    gridData={usersList}
                    totalVisualRecords={usersList?.length}
                    numberOfPage={filterData.pageSize}
                    numOfPage={numOfPage}
                    loader={loader}
                    currentPage={filterData.pageIndex}
                    totalPages={filterData.totalPages}
                    totalRecords={allPendingUsersData?.TotalRecords || 0}
                    setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                    setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
                />
            </div>
        </main>
    );
}

export default UserRequest;
